import { useState, useEffect } from 'react';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { getValues, getValueById } from './store/slice';
import { useLazyGetDashboardBaseCurrencyQuery } from './store/services';
import DashboardLeftSide from '../../components/dashboard/left-side';
// import DashboardRightSide from '../../components/dashboard/right-side';
import {
  DashboardValue,
  // ViewMode,
  TransactionsType,
  Period,
} from './types';

import cn from './dashboard.module.css';

const Dashboard = () => {
  // const [rightSideVisible, setRightSideVisible] = useState(false);
  // const [viewMode, setViewMode] = useState(ViewMode.GRID);
  const [selectedChart, setSelectedChart] = useState<
    | {
        value: DashboardValue;
        transactionsType?: TransactionsType;
        period?: Period;
        dates?: string[];
      }
    | undefined
  >(undefined);
  const [cardsEnabled, setCardsEnabled] = useState(true);

  const {
    dashboard: {
      transactions,
      cards,
      financial,
      customers,
      paymentTypes,
      item,
    },
    dashboardDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const [getDashboardBaseCurrency] = useLazyGetDashboardBaseCurrencyQuery();

  useEffect(() => {
    if (activePermissions?.includes(PermissionEnum.SECTION_DASHBOARD)) {
      getDashboardBaseCurrency();
      dispatch(getValues());
    }
  }, [dispatch, activePermissions]);

  useEffect(() => {
    if (transactions && transactions.values) {
      if (!selectedChart) {
        setSelectedChart({
          value: transactions.values[0],
          transactionsType: TransactionsType.INCOMING,
          period: Period.TODAY,
        });
      }

      if (!item.value) {
        dispatch(
          getValueById({
            transactionsType: TransactionsType.INCOMING,
            period: Period.TODAY,
          }),
        );
      }
    }
  }, [transactions, item, selectedChart]);

  useEffect(() => {
    const viewModeStorage = localStorage.getItem('viewMode');

    if (viewModeStorage) {
      // setViewMode(viewModeStorage as ViewMode.CHARTS);

      localStorage.removeItem('viewMode');
    }
  }, []);

  useEffect(() => {
    const cardsEnabledJSON = localStorage.getItem('cardsEnabled');

    if (cardsEnabledJSON) {
      const parsed = JSON.parse(cardsEnabledJSON);

      setCardsEnabled(parsed.cardsEnabled);
    }
  }, []);

  useEffect(() => {
    let title = 'Dashboard';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.dashboardLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (activePermissions.includes(PermissionEnum.SECTION_DASHBOARD)) {
      content = (
        <div className={cn.dashboardWrapper}>
          <div className={cn.dashboard}>
            <DashboardLeftSide
              // viewMode={viewMode}
              // setViewMode={setViewMode}
              // setRightSideVisible={setRightSideVisible}
              selectedChart={selectedChart}
              setSelectedChart={setSelectedChart}
              cards={cards}
              transactions={{
                values: transactions.values,
                count: transactions.totalCount,
              }}
              financial={{
                values: {
                  averageEmoney: financial?.values?.averageEmoney,
                  currentEmoney: financial?.values?.currentEmoney,
                  currentSafeguardedFunds:
                    financial?.values?.currentSafeguardedFunds,
                  netShareholderAssets: financial?.values?.netShareholderAssets,
                  excessEligibleEquity: financial?.values?.excessEligibleEquity,
                  profitLoss: financial.values?.profitLoss,
                  totalIncomingFunds: financial?.values?.totalIncomingFunds,
                  totalOutgoingFunds: financial?.values?.totalOutgoingFunds,
                },
              }}
              customers={{
                values: customers.values,
              }}
              paymentTypes={{
                values: paymentTypes.values,
              }}
              cardsEnabled={cardsEnabled}
            />
            {/* <DashboardRightSide
              selectedChart={selectedChart}
              // viewMode={viewMode}
              rightSideVisible={rightSideVisible}
              setRightSideVisible={setRightSideVisible}
              setSelectedChart={setSelectedChart}
              value={item.value}
              isLoading={item.isLoading}
              requestInProgress={item.requestInProgress}
            /> */}
          </div>
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Dashboard;
